/** @jsx h */
import { h } from 'preact'
import { StickyHeader } from './StickyHeader'
import Footer from './Footer'
import Results from './recycling/Results'
import Attribution from './recycling/Attribution'

const RecyclingCard = props =>
  <article class='ClaimCard'>
    <StickyHeader title='How to recycle this product' />
    <div class='ModalCard-content'>
      <section class='ModalCard-section'>
        <Results {...props} hideTopBorder />
        <Attribution />
      </section>
      <Footer />
    </div>
  </article>

export default RecyclingCard
